import React from "react";

const BookEarningCalculator = ({ param }) => {
  const levels = Array.from({ length: 8 }, (_, i) => i + 1);
  const commissionRates = [0.20, 0.04, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01];
  const customers = 5;

  const calculateCommission = (price, level) => {
    const rate = commissionRates[level - 1];
    const commission = price * rate * Math.pow(customers, level);
    return Number(commission.toFixed(2)).toLocaleString();
  };

  const calculateTotalCommission = (price, level) => {
    const rate = commissionRates[level - 1];
    const totalCommission =
      (price * rate * (Math.pow(customers, level) - 1)) /
      (customers - 1);
    return Number(totalCommission.toFixed(2)).toLocaleString();
  };

  return (
    <div className="w-full bg-black border border-green-400 p-2 rounded-lg shadow-lg mt-4 text-white">
      <div className="w-full flex flex-col place-items-center">
        <table className="text-white border-collapse text-xs sm:text-sm">
          <thead className="bg-gray-700">
            <tr>
              <th className="p-2 border w-12">Lvl</th>
              <th className="p-2 border w-28">Comm/Sale (₹)</th>
              <th className="p-2 border w-32">Total (₹)</th>
              <th className="p-2 border w-14">Rate</th>
              <th className="p-2 border w-16">Price</th>
              <th className="p-2 border w-24">Referrals</th>
            </tr>
          </thead>

          <tbody>
            {levels.map((level) => (
              <tr key={level} className="text-center">
                <td className="p-2 border">{level}</td>
                <td className="p-2 border">{calculateCommission(param, level)}</td>
                <td className="p-2 border">{calculateTotalCommission(param, level)}</td>
                <td className="p-2 border">{(commissionRates[level - 1] * 100).toFixed(2)}%</td>
                <td className="p-2 border">₹{param}</td>
                <td className="p-2 border">
                  5<sup>{level}</sup> = {5 ** level}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-white mt-4 text-sm lg:text-m flex flex-col place-items-left">
        <p className="font-semibold mb-2">N.B. -</p>
        <ol className="list-decimal ml-5 space-y-1 [&_li]:text-gray-100">
          <li>Think5Whys Referral is open to book buyers only.</li>
          <li>Get your product FREE — refer 5 customers.</li>
          <li>Platform can be a main/additional income source.</li>
          <li>Passive income up to Level 8 (~₹15 lakh lifetime).</li>
          <li>Super Ambassador Bonus for 5 lakh unit sales.</li>
          <li>New products & subscriptions added regularly.</li>
          <li>Estimates in ₹</li>
          <li>Overseas referrals may yield more income.</li>
          <li>Price includes 18% GST.</li>
        </ol>
      </div>
    </div>
  );
};

export default BookEarningCalculator;
